'use strict';

angular.module('atex.dam').controller('DamPublishingSchedulesController', ['$rootScope', '$q', '$modal', 'DamService', 'DamSchedulingService', '$scope','ContentService','DamNotificationService','$translate',
  function ($rootScope, $q,  $modal, DamService, DamSchedulingService, $scope,ContentService,DamNotificationService, $translate) {
    $translate(['__GENERIC_ERROR_MSG__', '__OPERATION_COMPLETED_SUCCESSFULLY__', '__PUBLISHING_SCHEDULE_CREATED__' ]).then(function (translations) {
      $scope.message = {};
      $scope.message.error = translations.__GENERIC_ERROR_MSG__;
      $scope.message.success = translations.__OPERATION_COMPLETED_SUCCESSFULLY__;
    });

    $scope.init = function () {
      $scope.loaded = false;
      $scope.showSpinner = true;
      DamSchedulingService.getAllSchedules().then(function (response) {
        $scope.planSchedules = response || [];
        $scope.loaded = true;
        $scope.showSpinner = false;
      }).then(null, function (error) {
        var message =  $scope.message.error + " (" + error.cause + ")";
        DamNotificationService.addNotification(atex.dam.Notification({type: 'error', message: message}), true);
      });
    };

    $scope.init();

    $scope.delete = function (key) {
      DamSchedulingService.deletePublishingSchedule($scope.planSchedules[key].id).then(function () {
        $scope.planSchedules.splice(key, 1);
        DamNotificationService.addNotification(atex.dam.Notification({type: 'success', message: $scope.message.success}), true);
      }).then(null, function (error){
        var message =  $scope.message.error + " (" + error.cause + ")";
        DamNotificationService.addNotification(atex.dam.Notification({type: 'error', message: message}), true);
      });
    };

    $scope.create = function () {
      var modalScope = $rootScope.$new(true);

      modalScope.model = {
        "isNew" : true,
        "message" : $scope.message
      };

      var modal = $modal({
        show: true,
        scope: modalScope,
        template: 'views/dam-publishing-schedules-modal.html',
        modalClass: 'dam-modal-edit confirm-modal ng-cloak',
        backdrop: 'static',
        keyboard: false
      });
      var destroyModal = function () {
        modal.then(function (modalEl) {
          modalEl.on('hidden.bs.modal', function () {
            modalScope.$destroy();
            angular.element(this).remove();
          });
          modalEl.modal('hide');
        });
      };
      modalScope.doCancel = function () {
        destroyModal();
      };
      modalScope.doOk = function (response) {
        destroyModal();
        DamSchedulingService.setOwnerDetails(response.data);
        $scope.planSchedules.push(response.data);
        DamNotificationService.addNotification(atex.dam.Notification({
          type: 'success',
          message: $scope.message.success
        }),false);
      };
    };

    $scope.edit = function (key, id) {
      
      var modalScope = $rootScope.$new(true);

      modalScope.model = {
        "isNew" : false,
        "id" : id,
        "message" : $scope.message
      };

      var modal = $modal({
        show: true,
        scope: modalScope,
        template: 'views/dam-publishing-schedules-modal.html',
        modalClass: 'dam-modal-edit confirm-modal ng-cloak',
        backdrop: 'static',
        keyboard: false
      });
      var destroyModal = function () {
        modal.then(function (modalEl) {
          modalEl.on('hidden.bs.modal', function () {
            modalScope.$destroy();
            angular.element(this).remove();
          });
          modalEl.modal('hide');
        });
      };
      modalScope.doCancel = function () {
        destroyModal();
      };
      modalScope.doOk = function (response) {
        destroyModal();
        $scope.planSchedules[key] = response.data;
        DamSchedulingService.setOwnerDetails(response.data);
        DamNotificationService.addNotification(atex.dam.Notification({
          type: 'success',
          message: $scope.message.success
        }),false);
      };
    };

    $scope.setSelectedRow = function (row) {
      $scope.selectedRow = row;
    };

    $scope.share = function (id) {
      var assignScope = $rootScope.$new(true);
      assignScope.id = id;
      var modal = $modal({
        show: true,
        scope: assignScope,
        template: 'views/dam-assign.html',
        modalClass: 'dam-modal-assign confirm-modal ng-cloak',
        backdrop: 'static',
        keyboard: false
      });
      var destroyModal = function () {
        modal.then(function (modalEl) {
          modalEl.on('hidden.bs.modal', function () {
            assignScope.$destroy();
            angular.element(this).remove();
          });
          modalEl.modal('hide');
        });
        $scope.init();
      };
      assignScope.doCancel = function () {
        destroyModal();
      };
      assignScope.doOk = function (response) {
        //update all existing schedule instances with the same contentAccess
        var contentAccess = atex.onecms.ObjectUtils.getByPath(response, "data/aspects/atex.dam.standard.ContentAccess");
        DamSchedulingService.getInstancesForSchedule(response.id).then(function (result){
          var promises = result.map(function (res){
            return DamSchedulingService.updateAssigneesForScheduleInstances(res, contentAccess).then(function () {
            });
          });
          return $q.all(promises);
        });

        destroyModal();
      };
    };

    $scope.isOwner = function (entry) {
      return entry.isOwner;
    };

    $scope.canShare = function (entry) {
      return entry.isOwner;
    };

    $scope.canEdit = function (entry) {
      return entry.isOwner;
    };

    $scope.canDelete = function (entry) {
      return entry.isOwner;
    };

    $scope.isInherited = function (entry) {
      return entry.isInherited;
    };

    $scope.isShared = function (entry) {
      return entry.isShared;
    };

  }]);